import { DetectBrand } from "../../mixins/brandDetector";
import { DetectWC } from "../../mixins/wcDetector";
var isWC = DetectWC.methods.isWC();
export function isStoreSelectionAtCheckout(store) {
  if (
    DetectBrand.methods.isBranded &&
    store.ViewComponentConfigs &&
    store.ViewComponentConfigs.StoreSelectionAtCheckout &&
    store.IsHQ
  ) {
    return true;
  }
  return false;
}

export function parseQueryString() {
  var str = window.location.search;
  if (isWC) {
    str = window.location.hash;
  }
  var objURL = {};

  str.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), function(
    $0,
    $1,
    $2,
    $3
  ) {
    objURL[$1] = decodeURIComponent($3);
  });
  return objURL;
}
export function getAddressFields(rawData) {
  const addressModel = {
    StreetAddress: "",
    PostalCode: "",
    CityTown: "",
    State: "",
    Phone: "",
    DeliveryInstructions: "",
    Latitude: "",
    Longitude: "",
    Country: "",
    address: "",
  };
  addressModel.Latitude = rawData.geometry.location.lat();
  addressModel.Longitude = rawData.geometry.location.lng();
  addressModel.address = rawData.address;
  for (var i = 0; i < rawData.address_components.length; i++) {
    var addressType = rawData.address_components[i].types[0];
    var val = rawData.address_components[i]["long_name"];

    if (addressType == "locality") {
      addressModel.CityTown = val;
    }

    if (addressType == "administrative_area_level_1") {
      addressModel.State = rawData.address_components[i]["short_name"];
    }

    if (addressType == "country") {
      addressModel.Country = val;
    }

    if (addressType == "street_number" && val) {
      addressModel.StreetAddress += val + " ";
    }
    if (addressType == "route") {
      addressModel.StreetAddress += val;
    }

    if (addressType == "postal_code") {
      addressModel.PostalCode = val;
    }
  }
  return addressModel;
}